import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { initAlpine } from './alpine'
import { header } from './header.js'
import { navigation } from './navigation.js'
import { archive } from './archive.js'
import { lenisScroll, scrollToStart, autoScroll } from './lenis-scroll.js'
import { animation } from './animation.js'
import { swiper } from './swiper.js'
// import { preloader } from './preloader.js'
import { homeBanner } from './home-banner.js'
import { map } from './map.js'
import { datepicker } from './datepicker.js'
import { initFormie } from './formie.js'
import { trustpilotWidget } from './trustpilot-widget.js'

let savedHash = ''

const initBarba = () => {

	barba.init({
		debug: false,
		schema: {
			prefix: 'data-load',
		},
		prevent: ({ el }) => el.classList.contains('ab-item'),
		transitions: [{
			name: 'basic-transition',
			once(data) {
				document.body.dataset.namespace = data.next.namespace || 'default'
				document.addEventListener('click', (e) => {
					const link = e.target.closest('a')
					if (link && link.hash) {
						savedHash = link.hash
					}
				})
				setTimeout(() => {
					// document.body.dataset.preloader = 'in-progress'
				}, 100);
				setTimeout(() => {
					document.body.dataset.preloader = 'complete'
				}, 0);
			},
			leave(data) {
				document.body.dataset.transition = 'in-progress'
				document.body.removeAttribute('data-navigation-status')
				const done = this.async()
				// console.log('leave')
				setTimeout(function () {
					done()
				}, 800)
				return gsap.to(data.current.container, { duration: 0.3, opacity: 0 })
			},
			enter(data) {
				// console.log('enter')
				document.body.dataset.namespace = data.next.namespace || 'default'
				document.body.dataset.transition = 'complete'
				document.addEventListener('click', (e) => {
					const link = e.target.closest('a')
					if (link && link.hash) {
						savedHash = link.hash
					}
				})
				document.body.dataset.headerTheme = data.next.container.dataset.headerTheme || 'dark'
				setTimeout(() => {
					const hash = savedHash || window.location.hash;
					if (hash) {
						setTimeout(() => {
							autoScroll(hash)
						}, 200)
					} else {
						// snapToTop()
					}
					savedHash = null
				}, 500)
			},
			after(data) {
				scrollToStart()
				return gsap.from(data.next.container, { duration: 0.3, opacity: 0 })
			}
		}]
	})

	barba.hooks.once((data) => {
		initAlpine()
		homeBanner()
		// preloader()
		archive()
		lenisScroll()
		navigation()
		header()
		animation()
		swiper()
		map()
		datepicker()
		trustpilotWidget()
	})

	barba.hooks.enter((data) => {
		if (htmx) {
			htmx.process(data.next.container)
		}
	})

	barba.hooks.after((data) => {
		homeBanner()
		archive()
		lenisScroll()
		animation()
		swiper()
		map()
		datepicker()
		initFormie()
		trustpilotWidget()
		// const scripts = document.querySelectorAll('main script')
		// scripts.forEach((script) => eval(script.innerHTML))
	})

}

export default initBarba